import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProportionalSaleState } from 'store/modules/proportional_sale_simulation_store/types';

interface SummaryBuyProps {
  serviceName: string;
  finalValue: number;
  baseValue: number;
  variationValue: number;
}

const SummaryBuy = (props: SummaryBuyProps) => {
  const { serviceName, finalValue, baseValue, variationValue } = props;
  const { proportional_sale } = useSelector<ApplicationState, ProportionalSaleState>(
    (state) => state.session.proportional_sale,
  );

  return (
    <div className="position-fixed">
      <h2>Resumo da compra</h2>
      <div className="card" style={{ width: '26rem' }}>
        <div className="card-body">
          <div>
            <div className="row">
              <div className="col-sm-8 card-text">{serviceName}</div>
              <div className="col-sm-4">
                {baseValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </div>
            </div>
            <hr className={`${proportional_sale?.payment_form === 10 ? 'd-block' : 'd-none'}`} />
            <div className="row">
              <div
                className={`col-sm-8 card-text ${
                  proportional_sale?.payment_form === 10 ? 'd-block' : 'd-none'
                }`}
              >
                <span className="font-weight-bold text-danger">Desconto</span>
              </div>
              <div
                className={`col-sm-4 font-weight-bold text-danger ${
                  proportional_sale?.payment_form === 10 ? 'd-block' : 'd-none'
                }`}
              >
                {variationValue.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-6">
                <h3 className="font-weight-bold ">Total</h3>
              </div>
              <div className="col-sm-6 text-center">
                <h3 className="font-weight-bold">
                  {finalValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryBuy;
